export default {
  TEMPLATES_MAILS_LIST: "Templates mails list",
  ADD_TEMPLATE_MAIL: "Add mail template",
  TEMPLATE_MAIL_ADDED: "Mail template added",
  EDIT_TEMPLATE_MAIL: "Edit mail template",
  TEMPLATE_MAIL_UPDATED: "Mail template updated",
  DELETE_THIS_TEMPLATE_MAIL: "Delete this mail template ?",
  TEMPLATE_MAIL_DELETED: "Mail template supprimée",
  SUBJECT: "Subject",
  TITLE: "Title",
  FROM : "From",
  TO : "To",
  CC : "Cc",
  BCC : "Bcc",
  TYPE : "Type",
  CONTENT: "Content",
  VIEW_TEMPLATE_MAIL: "Mail template",
  REPLY_TO: "Reply to",
  FROM_EMAIL: "Sender email",
  FROM_NAME: "Sender name",
  REPLY_TO_EMAIL: "Reply email",
  REPLY_TO_NAME: "Reply name",
  COMMUNICATION: "Communication",
  LOGO: "Logo",
  BACKGROUND_COLOR: "Background color",
  SECTION: "Section",
  FONT_SIZE: "Font size",
  FONT_FAMILY: "Fonts",
  TITLE_COLOR: "Title color",
  TEXT_COLOR: "Text color",
  LINKS_COLOR: "Links color",
  BUTTONS_COLOR: "Buttons color",
  PERSONNALISATION: "Customization",
  MAIL_CONTENT: "Mail content",
  IMPORT_LOGO: "Import logo",
  ADD_PICTURE: "Add picture",
  IS_DEFAULT_TEMPLATE: "Default template",
  FOOTER_COLOR: "Footer color",
  CLONE: "Clone",
  CLONE_THIS_TEMPLATE_MAIL: "Clone this mail template?",
  TEMPLATE_MAIL_CLONED: "Mail template cloned",
  HTML_CONTENT: "HTML Content",
  AVAILABLE_VARIABLES: "Available variables",
  SOURCE_CODE: "Source code",
  EMAIL_BUILDER: "Email Builder",
  GENERAL_INFO: "General Information",
  SENDER_RECIPIENTS: "Sender / Recipients",
  EDIT_LANGUAGE: "Edit language",
  VARIABLES_HINT: "Click a variable to insert it into the editor.",
};
